<template>
    <!-- TABELA -->
    <div class="md-layout-item md-size-100">
        <md-card class="pl-1 pr-1">
            <md-card-header class="pb-0">
                <h4 class="title pt-1">
                    Parâmetros por {{ parameterTypeTitle }}
                </h4>
            </md-card-header>
            <md-card-content class="pb-2">
                <md-button
                    v-if="selectedAll"
                    class="md-just-icon md-simple"
                    @click="selectAll()"
                >
                    <md-icon>check_box</md-icon>
                </md-button>
                <md-button
                    v-else
                    class="md-just-icon md-simple"
                    @click="selectAll()"
                >
                    <md-icon>check_box_outline_blank</md-icon>
                </md-button>
                <md-button
                    class="md-just-icon md-simple"
                    @click="actionModalOpen(selectedBranches)"
                    v-if="
                        selectedBranches.length > 0 &&
                            simulation &&
                            simulation.is_daily
                    "
                >
                    <md-icon>lock</md-icon>
                </md-button>
                <md-button
                    class="md-just-icon md-simple"
                    v-if="selectedBranches.length > 0"
                    @click="similarProductModalOpen(selectedBranches)"
                >
                    <md-icon>content_copy</md-icon>
                </md-button>
                <md-button
                    class="md-just-icon md-warning md-simple"
                    v-if="selectedBranches.length > 0"
                    @click="editModalOpen(selectedRows)"
                >
                    <md-icon>edit</md-icon>
                </md-button>
                <md-button
                    class="md-just-icon md-primary md-simple"
                    v-if="canUndoMany"
                    @click="undo(selectedRows)"
                >
                    <md-icon>add</md-icon>
                </md-button>
                <md-button
                    class="md-just-icon md-danger md-simple"
                    v-if="canRemoveMany"
                    @click="remove(selectedBranches)"
                >
                    <md-icon>delete</md-icon>
                </md-button>

                <md-table
                    :value="parameters.results"
                    class="paginated-table table-striped table-hover"
                    md-fixed-header
                >
                    <md-table-row
                        slot="md-table-row"
                        slot-scope="{ item }"
                        @mouseenter="tableHoverRow = item.id"
                        @mouseleave="tableHoverRow = null"
                        v-bind:class="{
                            removed: item.status == 'M' || item.status == 'R'
                        }"
                    >
                        <md-table-cell style="width: 0px; display: hidden;">
                            <md-checkbox
                                v-model="selectedBranches"
                                :value="item.branch"
                            ></md-checkbox>
                        </md-table-cell>
                        <md-table-cell
                            v-for="column in visibleColumns"
                            :md-label="columnNames[column]"
                            :md-sort-by="column"
                            :key="column"
                            :title="item[column]"
                            :class="{
                                'cell-highlight':
                                    (item['status'] == 'R' &&
                                        column == 'suggested_stock') ||
                                    (column == 'considered_stock_coverage' &&
                                        item['considered_stock_coverage'] >
                                            item['coverage_max'])
                            }"
                        >
                            {{
                                column == 'branch'
                                    ? item['branch_external_id'] +
                                      ' - ' +
                                      item['branch_name']
                                    : column === 'guaranteed_stock'
                                    ? item['guaranteed_stock']
                                        ? 'Sim'
                                        : 'Não'
                                    : column === 'type_sale'
                                    ? item['type_sale'] === 'S'
                                        ? 'Saída Loja'
                                        : 'Saída CD'
                                    : column == 'total_stock'
                                    ? formatNumber(
                                          item['showcase_items'] +
                                              item['stack_items'],
                                          'int'
                                      )
                                    : column === 'is_favorite'
                                    ? item['is_favorite']
                                        ? 'Sim'
                                        : 'Não'
                                    : column == 'suggested_stock' &&
                                      item['status'] == 'R'
                                    ? '0'
                                    : formatNumber(
                                          item[column],
                                          fieldTypes[column]
                                      )
                            }}
                        </md-table-cell>
                        <md-table-cell class="td-actions">
                            <div
                                v-if="tableHoverRow == item.id"
                                style="padding: 7px"
                            >
                                <md-button
                                    class="md-just-icon md-simple"
                                    @click="actionModalOpen([item])"
                                    v-if="simulation && simulation.is_daily"
                                >
                                    <md-icon>lock</md-icon>
                                </md-button>
                                <md-button
                                    class="md-just-icon md-simple"
                                    @click="similarProductModalOpen([item.id])"
                                >
                                    <md-icon>content_copy</md-icon>
                                </md-button>
                                <md-button
                                    class="md-just-icon md-warning md-simple"
                                    @click="editModalOpen([item])"
                                >
                                    <md-icon>edit</md-icon>
                                </md-button>
                                <md-button
                                    class="md-just-icon md-primary md-simple"
                                    v-if="
                                        (parameterType !== 'branch-parameter' &&
                                            item.status != 'A') ||
                                            (parameterType ===
                                                'branch-parameter' &&
                                                !item.active)
                                    "
                                    @click="undo([item])"
                                >
                                    <md-icon>add</md-icon>
                                </md-button>
                                <md-button
                                    class="md-just-icon md-danger md-simple"
                                    @click="remove([item.branch])"
                                    v-if="
                                        (parameterType !== 'branch-parameter' &&
                                            item.status === 'A') ||
                                            (parameterType ===
                                                'branch-parameter' &&
                                                item.active)
                                    "
                                >
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </div>
                        </md-table-cell>
                    </md-table-row>
                </md-table>

                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando
                            <select
                                id="numberItemPage"
                                v-model="pagination.perPage"
                            >
                                <option value="20">20</option>
                                <option value="40">40</option>
                                <option value="60">60</option>
                                <option value="80">80</option>
                                <option value="100">100</option>
                            </select>
                            itens de um total de {{ total }}.
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import { Pagination } from '@/components'
import { mapActions } from 'vuex'
import Utils from '@/utils'
import { BranchParameter } from '@/models/branchparameter.model'
import { DCParameter } from '@/models/dcparameter.model'

export default {
    props: {
        baseStore: { type: String, required: true },
        parameterType: {
            type: String,
            required: true,
            validator: value =>
                ['branch', 'dc', 'branch-parameter'].indexOf(value) !== -1
        },
        parameterTypeTitle: {
            type: String,
            required: true
        },
        parameters: {
            type: Object,
            required: true
        },
        simulation: {
            type: Object,
            default: null
        },
        // these functions may be unset when the component is created
        // they are expected to be set afterwards
        editModalOpen: {
            type: Function,
            default: null
        },
        actionModalOpen: {
            type: Function,
            default: null
        },
        similarProductModalOpen: {
            type: Function,
            default: null
        }
    },
    async created() {
        this.readParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/read',
                ...arguments
            ])
        }
        this.updateParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/update',
                ...arguments
            ])
        }
        this.removeParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/remove',
                ...arguments
            ])
        }
    },
    components: {
        Pagination
    },
    computed: {
        visibleColumns() {
            const Model =
                this.parameterType === 'branch-parameter' ||
                this.parameterType === 'branch'
                    ? BranchParameter
                    : DCParameter

            let columns = []
            if (this.simulation && this.simulation.is_daily)
                Object.keys(Model.visibleFieldsDaily).forEach(key => {
                    if (Model.visibleFieldsDaily[key]) columns.push(key)
                })
            else
                Object.keys(Model.visibleFields).forEach(key => {
                    if (
                        key === 'guaranteed_stock' &&
                        this.parameterType === 'branch-parameter' &&
                        Model.visibleFields[key]
                    )
                        columns.push(key)
                    else if (
                        key !== 'guaranteed_stock' &&
                        Model.visibleFields[key]
                    )
                        columns.push(key)
                })
            return columns
        },
        selectedRows() {
            return this.parameters.results.filter(
                a => this.selectedBranches.filter(b => a.branch == b).length > 0
            )
        },
        canUndoMany() {
            return (
                this.selectedRows.filter(
                    a =>
                        (this.parameterType !== 'branch-parameter' &&
                            a.status != 'A') ||
                        (this.parameterType === 'branch-parameter' && !a.active)
                ).length > 0
            )
        },
        canRemoveMany() {
            return (
                this.selectedRows.filter(
                    a =>
                        (this.parameterType !== 'branch-parameter' &&
                            a.status === 'A') ||
                        (this.parameterType === 'branch-parameter' && a.active)
                ).length > 0
            )
        },
        to() {
            if (this.parameters.results.length > 0)
                return this.parameters.results[
                    this.parameters.results.length - 1
                ].id
            else return 0
        },
        from() {
            if (this.parameters.results.length > 0)
                return this.parameters.results[0].id
            else return 0
        },
        total() {
            return this.parameters.count
        }
    },
    data() {
        return {
            columnNames:
                this.parameterType === 'branch-parameter' ||
                this.parameterType === 'branch'
                    ? BranchParameter.fieldNames
                    : DCParameter.fieldNames,
            fieldTypes:
                this.parameterType === 'branch-parameter' ||
                this.parameterType === 'branch'
                    ? BranchParameter.fieldTypes
                    : DCParameter.fieldTypes,

            selectedAll: false,
            selectedBranches: [],
            tableHoverRow: null,

            removeLoading: false,

            // dynamic methods
            readParameters: null,
            updateParameters: null,
            removeParameters: null,

            pagination: {
                perPage: 20,
                currentPage: 1,
                total: 0
            }
        }
    },
    methods: {
        ...mapActions('simulations', {
            createClone: 'createClone'
        }),

        formatNumber: (number, type) => Utils.formatNumber(number, type),

        selectAll() {
            if (this.selectedAll) this.selectedBranches = []
            else
                this.selectedBranches = this.parameters.results.map(
                    a => a.branch
                )

            this.selectedAll = !this.selectedAll
        },

        // REMOVE PARAMS
        async remove(selectedBranches) {
            if (selectedBranches.length < 1) return

            this.removeLoading = true

            if (!this.simulation.clone) {
                await this.createClone(this.simulation.id)
            }

            let removeParams = { simulation: this.simulation.clone }
            if (this.parameterType == 'branch')
                removeParams.branch_ids = selectedBranches
            else if (this.parameterType == 'dc')
                removeParams.dc_ids = selectedBranches

            await this.removeParameters(removeParams)

            this.removeLoading = false
            this.selectedBranches = []
        },

        // UNDO REMOVE PARAMS
        async undo(selectedParams) {
            selectedParams = selectedParams
                .filter(
                    a =>
                        (a.status != 'A' &&
                            this.parameterType !== 'branch-parameter') ||
                        (!a.active && this.parameterType === 'branch-parameter')
                )
                .map(a => a.branch)

            if (this.simulation && !this.simulation.clone) {
                await this.createClone(this.simulation.id)
            }

            let undoField = new Model()

            if (this.simulation) {
                undoField.simulation = this.simulation.clone
            }

            if (this.parameterType == 'branch')
                undoField.branch_ids = selectedParams.reduce(
                    (acc, current, i) => acc + ',' + current
                )
            else if (this.parameterType == 'dc')
                undoField.dc_ids = selectedParams.reduce(
                    (acc, current, i) => acc + ',' + current
                )

            await this.updateParameters(undoField)

            if (this.simulation) {
                await this.readParameters({
                    simulation: this.simulation.clone
                })
            }

            this.selectedBranches = []
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                if (val.perPage) val.perPage = parseInt(val.perPage)
                this.readParameters({
                    page: val.currentPage,
                    limit: val.perPage,
                    ...(this.simulation && { simulation: this.simulation.id })
                })
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" scoped>
.removed {
    color: rgb(97, 0, 0);
}
.cell-highlight {
    background: #f5dddd;
}
</style>
